import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Table, Card } from 'react-bootstrap'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const SiteList = ({ newSite }) => {
  const [sites, setSites] = useState([])

  // const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    // Check for authentication token
    const token = Cookies.get('authToken')
    if (!token) {
      // If token is not found, redirect to login page
      window.location.href = '/login'
    }
  }, [])

  const buttonStyle = {
    transition: 'transform 0.3s ease',
  }
  const buttonHoverstyle = {
    transform: 'scale(1.2)',
  }
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    const fetchSiteData = async () => {
      // setError('')
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        const response = await axios.get(
          BASE_URL+'/sites',

          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )
        // toast.success(response.data.message || 'Customer created successfully ')

        if (response.data.data && response.data.data.length === 0) {
          setSites([])
        } else {
          setSites(response.data.data)
        }
        setSites(response.data.data)
      } catch (err) {
        toast.error(err.response?.data?.message || 'No Sites are available ')
      } finally {
        setLoading(false)
      }
    }
    fetchSiteData()
  }, [])

  return (
  <Container className="pb-3" style={{fontFamily: theme.font.family }}>
        <div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>

          <Table
            bordered
            hover
            responsive="md"
            className="text-center  table table-bordered table-hover"
          >
            <thead className="position-sticky top-0  text-start">
                <tr className="text-start">
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Site Name</th>
                  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Site Location</th>
                </tr>
                
            </thead>
            <tbody className="text-start">
              {/* Conditionally render a message  */}
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    Loading sites...
                  </td>
                </tr>
              ) : sites.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-danger ">
                    No sites are available
                  </td>
                </tr>
              ) : null}
              {sites.map(
                (site) =>
                  site.name != null && (
                    <tr key={site._id}>
                      <td>{site.name}</td>
                      <td>{site.location}</td>
                    </tr>
                  ),
              )}
            </tbody>
          </Table>
 
        </div>
   
    </Container>
  )
}

export default SiteList
